import React from "react";
import { Redirect } from "react-router-dom";
import { Container } from "react-bootstrap";
import AddProductForm from "../../components/AddProductForm";
import useAuth from "../../contexts/auth";

export default function AddProductPage() {
    const { user } = useAuth();

    if (!user) return <Redirect to="/entrar" />;
    if (user.type !== "poster" && user.type !== "admin")
        return <Redirect to="/" />;

    return (
        <Container className="py-4">
            <h3 className="mb-4 text-primary">Adicionar Nova Oferta</h3>
            <AddProductForm />
        </Container>
    );
}
